export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item.organization.business_name;
                    }
                },
                {
                    title: 'Referencia de transacción',
                    type: 'custom-html',
                    key: 'transaction_reference',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Monto',
                    type: 'custom-html',
                    key: 'amount',
                    modifier: (item) => {
                        return item.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                    }
                },
                {
                    title: 'Descripción',
                    type: 'custom-html',
                    key: 'product_description',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Fecha de Pago',
                    type: 'custom-html',
                    key: 'payment_date',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Cuotas',
                    type: 'custom-html',
                    key: 'installments',
                    modifier: (item) => {
                        return item;
                    }
                },

                {
                    title: 'Tarjeta',
                    type: 'custom-html',
                    key: 'bin',
                    modifier: (item) => {
                        return `${item}XXXXXXXXXX`;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'current_status',
                    modifier: (item) => {
                        let tmp;
                        if (item == 'APPROVED') {
                            tmp = `<span class="badge badge-sm badge-pill badge-success">Aprobado</span>`;
                        } else if (item == 'PENDING') {
                            tmp = `<span class="badge badge-sm badge-pill badge-warning">Pendiente</span>`;
                        } else if (item == 'REJECTED') {
                            tmp = `<span class="badge badge-sm badge-pill badge-danger">Rechazado</span>`;
                        } else if (item == 'REFUNDED') {
                            tmp = `<span class="badge badge-sm badge-pill badge-warning">Reembolsado</span>`;
                        }
                        return tmp;
                    }
                },
                {
                    title: 'Descripción estado',
                    type: 'custom-html',
                    key: 'status_detail',
                    modifier: (item) => {
                        let res;
                        if (item == 3) {
                            res = 'Transacción aprobada';
                        } else if (item == 9) {
                            res = 'Transacción denegada';
                        } else if (item == 1) {
                            res = 'Transacción en revisión';
                        } else if (item == 11) {
                            res = 'Transacción rechazada por sistema de fraude';
                        } else if (item == 12) {
                            res = 'Tarjeta en lista negra';
                        } else if (item == 7) {
                            res = 'Transacción reembolsada';
                        } else {
                            res = '';
                        }
                        return res;
                        
                    }
                },
                
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}